import React from "react";

function Logo() {
  return (
    <a href="/" className="flex items-center gap-2 no-underline">
      <span className="font-['Figtree',sans-serif] font-black text-[#07001a] text-[20px] tracking-[-0.4px]">
        evo
      </span>
    </a>
  );
}

function Card({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-white rounded-[24px] shadow-[0px_8px_32px_rgba(0,0,0,0.08)] p-8 w-full max-w-[440px] relative">
      <div
        aria-hidden="true"
        className="absolute border border-[rgba(0,6,20,0.05)] border-solid inset-0 pointer-events-none rounded-[24px]"
      />
      {children}
    </div>
  );
}

export default function UnsubscribeSuccess() {
  return (
    <div className="min-h-screen bg-[#faf9fb] flex flex-col">
      <header className="flex items-center justify-between px-6 py-4">
        <Logo />
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <Card>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-8 rounded-full bg-[#f0fce8] flex items-center justify-center shrink-0">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M3 8l3.5 3.5L13 4.5"
                  stroke="#44B300"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <h1 className="font-['Figtree',sans-serif] font-black text-[#07001a] text-[22px] tracking-[-0.44px]">
              You've been unsubscribed
            </h1>
          </div>
          <p className="font-['Figtree',sans-serif] text-[#776f7b] text-[15px] leading-relaxed">
            You won't receive any more marketing emails from us. You'll still
            get important account messages like grade results and receipts.
          </p>
        </Card>
      </main>

      <footer className="text-center pb-8">
        <p className="font-['Figtree',sans-serif] text-[#776f7b] text-[13px]">
          evograding.com &middot;{" "}
          <a
            href="mailto:hello@evograding.com"
            className="underline text-[#776f7b]"
          >
            hello@evograding.com
          </a>
        </p>
      </footer>
    </div>
  );
}
